(function () {
  $(document).on("turbolinks:load", function () {
    if (!!$("#js-table-of-contents").length) {
      const contentsList = document.getElementById("js-table-of-contents"); // 目次を追加する先(table of contents)
      const div = document.createElement("div"); // 作成する目次のコンテナ要素
      const matches = document.querySelectorAll(".article__title");

      // 取得した見出しタグ要素の数だけ以下の操作を繰り返す
      matches.forEach(function (value, i) {
        // 見出しタグ要素のidを取得し空の場合は内容をidにする
        let id = value.id;
        if (id === "") {
          id = value.textContent;
          value.id = id;
        }
        const ul = document.createElement("ul");
        const li = document.createElement("li");
        const a = document.createElement("a");

        // MEMO: 管理画面(?)で適切な目次表示にならない場合があるためchildNodesから参照するようにした
        // a.innerHTML = value.innerText;
        a.innerHTML = value.childNodes[0].wholeText;
        a.href = "#" + value.id;
        // 追加する<ul><li><a>タイトル</a></li></ul>を準備する
        li.appendChild(a);
        ul.appendChild(li);

        try {
          switch (value.tagName) {
            case "H2":
              div.appendChild(ul);
              break;
            case "H3":
              div.lastElementChild.lastElementChild.appendChild(ul);
              break;
            case "H4":
              div.lastElementChild.lastElementChild.lastElementChild.appendChild(
                ul,
              );
              break;
            default:
              break;
          }
        } catch {
          if ( window.location.pathname.includes( 'admin' ) ) {
            const targetContent = `${ value.childNodes[ 0 ].wholeText.trim() }`
            alert( `⚠️目次が表示されません⚠️ 前後の見出しサイズが間違っている可能性があります. 次の見出し付近の文書構造を確認してください. \n${ targetContent }` )
          }
        }
      });
      // 最後に画面にレンダリング
      contentsList.appendChild(div);

    }

    const h2 = document.querySelector('.l-detail__content > h2')

    // const endDay = new Date(2023, 7, 12);
    // const _today = new Date();
    // const today = new Date(_today.getFullYear(), _today.getMonth(), _today.getDate(), 0, 0, 0);
    // const termDay = (endDay - today) / 86400000;
    // console.log(termDay)

    if (h2) {
      const questionnaireHTML = `
      <div class="p-recommended_area">
        <span class="p-recommended_area__supplement">
          今なら会員登録から60日間無料で見放題
        </span>
        <span class="p-recommended_area__button c-button--recommended">
          GitHub Copilot 教材
        </span>

        <p>
          <a href="/lps/github_copilot" target="_blank">
            <img 
              src="https://programan.s3.amazonaws.com/uploads/content_image/dummy_evcJv6YPBZGhBN95Jxl1uQ_01.png" 
              alt="GitHubCopilotカリキュラムのh2下バナー" 
              class="js-h2_counts_by_github_copilot_h2_image"
            >
          </a>
        </p>

        <div class="p-fukidashi-conversation" style="margin:0 16px">
          <div class="p-fukidashi-conversation__pikawaka__bubble" style="background: #fff">
            <p class="p-fukidashi-conversation__pikawaka__bubble__text" style="padding-top:0">
              GitHub Copilotの実践的なカリキュラムが、今なら60日間無料で閲覧し放題のキャンペーン中！
            </p>
          </div>
          <figure class="p-fukidashi-conversation__pikawaka">
            <div class="p-fukidashi-conversation__pikawaka-image"></div>
          </figure>
        </div>

        <p style="margin:14px 16px 0">
          <b>合計26演習記事</b>の大ボリューム！<br>
          ハンズオン形式の演習だから実践的な知識がすぐに身に付きます。
        </p>

        <p style="margin:14px 16px 0">
          生成AIコーディングツール「GitHub Copilot」を使ったことがない方でも、ツール代・教材代ともに無料で、基礎から安心して学べる内容です。<br>
          カリキュラムはGitHub社の「Copilotベストプラクティス」に基づいた実務直結型なので、現場で成果につながるスキルを体系的に習得できます。
        </p>

        <p style="margin:14px 16px 0">
          現場を想定したケーススタディ＆テンプレート付きだから、学んだ瞬間から自分の開発に取り入れて、すぐに効率を高められるPikawakaオリジナルのカリキュラムです。
        </p>

        <div class="p-school_button_area single">
          <a 
            class="c-button--affiliate-official-site-button js-h2_counts_by_github_copilot_h2_button" 
            href="/lps/github_copilot" 
            target="_blank"
          >
            GitHub Copilotカリキュラムの詳細をみる
          </a>
        </div>
      </div>
      `

      const adsenseHTML = location.host == 'pikawaka.com' ? `
        <ins class="adsbygoogle" data-ad-client="ca-pub-5447545650906273" data-ad-format="horizontal" data-ad-slot="4848620315" data-full-width-responsive="false" style="display:block; width: 100%; margin: 0 auto; overflow: hidden;"></ins>
        <script>(adsbygoogle = window.adsbygoogle || []).push({})</script>
      ` : ''

      const node = document.createElement( 'div' )
      node.innerHTML = questionnaireHTML + adsenseHTML
      h2.parentElement.insertBefore(node, h2)
    }

    if (!!$(".js-header-link").length) {
      document.querySelectorAll(".js-header-link").forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          const nextPath = $(e.currentTarget)
            .find("a")
            .attr("href");
          const copyIdPath = location.origin + location.pathname + nextPath;
          const visibleTextArea = document.createElement("textarea");
          visibleTextArea.className = "js-will-delete";
          visibleTextArea.textContent = copyIdPath;
          visibleTextArea.style.position = "fixed";
          visibleTextArea.style.left = "-100%";
          document.body.appendChild(visibleTextArea);
          visibleTextArea.select();
          document.execCommand("copy");
          $(e.currentTarget)
            .find(".notice-balloon-type-copy")
            .fadeIn("fast")
            .delay(1000)
            .fadeOut();
          $(".js-will-delete").remove();
        });
      });
    }

    // クリックした時にリロードされてしまうため、anchor linkの場合は preventDefault() する
    // ref: https://github.com/turbolinks/turbolinks/issues/75#issuecomment-244915109
    $(document).on("turbolinks:click", function (event) {
      if (event.target.getAttribute("href").charAt(0) === "#") {
        return event.preventDefault();
      }
    });
  });
})();
